import { isPublisher } from '~/helpers'

import PublisherAudienceTabs from './Publisher'

const AudienceInnerTabs = () =>
  isPublisher() ? <PublisherAudienceTabs /> : <></>

export default AudienceInnerTabs
